import React from 'react';
import styled from '@emotion/styled';
import { Container, Button, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import notFoundImg from '../../assets/images/not_found.png';

const NotFound = () => {
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  return (
    <StyledContainer sx={{ pt: 3 }}>
      <img src={notFoundImg} alt="page not found" style={{ marginRight: 10 }} />
      <StyledBoxContent>
        <StyledTitle>Uh-Oh</StyledTitle>
        <StyledParagraphText>Looks like something went wrong</StyledParagraphText>
        <StyledParagraphText>Please try again or return to the previous page</StyledParagraphText>
        <StyledButtonBack variant="contained" sx={{ mt: 2 }} onClick={goBack}>
          Go Back
        </StyledButtonBack>
      </StyledBoxContent>
    </StyledContainer>
  );
};

export default NotFound;

const StyledContainer = styled(Container)(() => `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  min-height: calc(100vh - 357px);
`);

const StyledBoxContent  = styled(Box)(({ theme }) => `
  margin-left: ${theme.spacing(-17)};
  margin-top: ${theme.spacing(15)};
`);

const StyledTitle  = styled.h1(() => `
  font-size: 7rem;
  line-height: 8rem;
  margin: 0;
`);

const StyledParagraphText  = styled.p(() => `
  font-size: 1.1rem;
  margin: 0;
`);

const StyledButtonBack  = styled(Button)(() => `
  text-transform: none;
  font-size: 1.1rem;
`);